<template>
  <div>
    <b-form-group label="Dados do Pai">
      <parents-data label="pai" name="father" v-model="value.parents_data.father" />
    </b-form-group>
    <b-form-group label="Dados da Mãe">
      <parents-data label="mãe" name="mother" v-model="value.parents_data.mother" />
    </b-form-group>
    <b-form-group >
      <validation-provider
                name="Participou"
                :rules="{ required: true }"
                v-slot="validationContext"
              >
            <b-form-group label="Algum dos pais animou um campo/foi da Direção?">
              <b-form-radio-group
                id="radio-slots"
                v-model="value.parents_participated"
                :options="yesNoOptions"
                :state="validateState(validationContext)"
                name="parents_participated"
              ></b-form-radio-group>
            </b-form-group>
      </validation-provider>
      <validation-provider
                name="Quem Participou"
                :rules="{ required: true }"
                v-slot="validationContext"
                v-if="value.parents_participated == 1"
              >
            <b-form-group label="Quem e quando?">
              <b-form-textarea name="parents_part_detail" v-model="value.parents_part_detail" :state="validateState(validationContext)"></b-form-textarea>
            </b-form-group>
      </validation-provider>
    </b-form-group>
  </div>
</template>
<script>
import ParentsData from './parents_data.vue'
import Base from './base'
export default  {
  name: "ParentsForm",
  extends: Base,
  components: { ParentsData },
};
</script>
